export type ResolvedIdp = { type: 'sso'; provider: string } | { type: 'password' };

const parseDomainIdpMap = (): Record<string, string> => {
  if (!import.meta.env.VITE_DOMAIN_IDP_MAP) return {};

  try {
    return JSON.parse(import.meta.env.VITE_DOMAIN_IDP_MAP);
  } catch {
    return {};
  }
};

const domainIdpMap: Record<string, string> = parseDomainIdpMap();

// terraform provisions at most one SAML IDP per client env (VITE_EXTERNAL_IDENTITY_PROVIDER, e.g.
// "azure-ct-bms-prod"). Any email domain not explicitly listed in VITE_DOMAIN_IDP_MAP still routes
// to that one IDP rather than the password/unavailable path — with only one real IDP configured,
// there's nowhere else a genuine SSO user could be trying to go, so an unconfirmed/legacy domain
// for the same client is treated the same as a confirmed one rather than surfacing a dead end.
const defaultProvider = import.meta.env.VITE_EXTERNAL_IDENTITY_PROVIDER || undefined;

export const resolveIdpFromEmail = (email: string): ResolvedIdp => {
  const domain = email.toLowerCase().split('@')[1];
  const provider = (domain ? domainIdpMap[domain] : undefined) ?? defaultProvider;
  return provider ? { type: 'sso', provider } : { type: 'password' };
};
